import script from "./ReservationDialogHall.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationDialogHall.vue?vue&type=script&setup=true&lang=js"

import "./ReservationDialogHall.vue?vue&type=style&index=0&id=850c3b58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-850c3b58"]])

export default __exports__